import { vnTemplate } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { amCharts_v4_date_basic_template } from './amCharts_v4_date_basic_template';
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { presetFilter_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template';
import { infoButton_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template';
import { resultsInfo_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template';
import { exportDataCsv } from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";

declare var ko: any;

export class accountDashboard_template extends vnTemplate {

    protected dateRangeFilter: filterDate_template;
    protected accountsGraph: amCharts_v4_date_basic_template;
    protected pagination: pagination_template;
    protected presetFilter: presetFilter_template;
    protected averageViewsTooltip: infoButton_template;
    protected averageEventsTooltip: infoButton_template;
    protected resultsInfo: resultsInfo_template;
    protected exportDataCsv: exportDataCsv;

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        return `
            <div id="report-results">

                <div class="page-header">
                    <div class="button-default-group">
                    </div>

                    <h2 class="title-page">Accounts Dashboard</h2>
                </div>

                <div class="list-results-header w-justify block-filters">
                    <div class="w-left">
                        ${this.dateRangeFilter.getHtmlBuild()}
                    </div>
                    <div class="w-center">
                         ${this.resultsInfo.getHtmlBuild()}
                    </div>
                    <div class="w-right">
                        <button class="button-default icon i-export" type="button" data-bind="event: {click: onExportData}">Export</button>
                        ${this.pagination.getHtmlBuild()}
                    </div>

                </div>

                <div id="accountsTable-results" class="gradient-overflow " style="min-height: 200px;margin-top: -10px;">
                    <div class="w-list-results" style="min-height: 200px;">
                        <table class="list-results thin">
                            <thead>
                                <tr>
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'accountName')}, css: {'i-sort-up': tableOrdering().col == 'accountName' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'accountName' && tableOrdering().dir == 'DESC'}">
                                        <span class="icon i-sort">Account</span>
                                    </th>
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'idPlanCurrent')}, css: {'i-sort-up': tableOrdering().col == 'idPlanCurrent' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'idPlanCurrent' && tableOrdering().dir == 'DESC'}">
                                        <span class="icon i-sort">Current Plan</span>
                                    </th>
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'idPlanOriginal')}, css: {'i-sort-up': tableOrdering().col == 'idPlanOriginal' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'idPlanOriginal' && tableOrdering().dir == 'DESC'}">
                                        <span class="icon i-sort">Original Plan</span>
                                    </th>
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'timezone')}, css: {'i-sort-up': tableOrdering().col == 'timezone' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'timezone' && tableOrdering().dir == 'DESC'}">
                                        <span class="icon i-sort">Timezone</span>
                                    </th>
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'adPlatform')}, css: {'i-sort-up': tableOrdering().col == 'adPlatform' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'adPlatform' && tableOrdering().dir == 'DESC'}">
                                        <span class="icon i-sort">Ad Platform</span>
                                    </th> 
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'adTrackingId')}, css: {'i-sort-up': tableOrdering().col == 'adTrackingId' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'adTrackingId' && tableOrdering().dir == 'DESC'}">
                                        <span class="icon i-sort">Ad Tracking ID</span>
                                    </th>                                    
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'userCount')}, css: {'i-sort-up': tableOrdering().col == 'userCount' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'userCount' && tableOrdering().dir == 'DESC'}">
                                        <span class="icon i-sort">User Count</span>
                                    </th>
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'properties')}, css: {'i-sort-up': tableOrdering().col == 'properties' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'properties' && tableOrdering().dir == 'DESC'}">
                                        <span class="icon i-sort">Properties</span>
                                    </th>
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'ownerEmail')}, css: {'i-sort-up': tableOrdering().col == 'ownerEmail' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'ownerEmail' && tableOrdering().dir == 'DESC'}">
                                        <span class="icon i-sort">Owner Contact</span>
                                    </th>
                                    <th>
                                        <div data-bind="event: {click: onReorderTableData.bind(this, $data, 'averageViews3Day')}, css: {'i-sort-up': tableOrdering().col == 'averageViews3Day' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'averageViews3Day' && tableOrdering().dir == 'DESC'}"><span class="icon i-sort">Avg Views/Day</span></div>
                                        <div class="w-tooltips-adv auto-height short pos-right-tight in-list" data-bind="template: { name: 'infoButton-template', data: getAvgViewsTooltip().getTemplateViewModel() }"></div>
                                    </th>
                                    <th>
                                        <div data-bind="event: {click: onReorderTableData.bind(this, $data, 'averageEvents3Day')}, css: {'i-sort-up': tableOrdering().col == 'averageEvents3Day' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'averageEvents3Day' && tableOrdering().dir == 'DESC'}"><span class=" icon i-sort">Avg Events/Day</span></div>
                                        <div class="w-tooltips-adv auto-height short pos-right-tight in-list" data-bind="template: { name: 'infoButton-template', data: getAvgEventsTooltip().getTemplateViewModel()  }"></div>
                                    </th>
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'dateAccountCreated')}, css: {'i-sort-up': tableOrdering().col == 'dateAccountCreated' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'dateAccountCreated' && tableOrdering().dir == 'DESC'}">
                                        <span class=" icon i-sort">Account Created</span>
                                    </th>
                                    <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'isActive')}, css: {'i-sort-up': tableOrdering().col == 'isActive' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'isActive' && tableOrdering().dir == 'DESC'}">
                                        <span class=" icon i-sort">Status</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- ko foreach: accountsTableData -->
                                    <tr>
                                        <td>
                                            <span data-bind="text: $data.accountName"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: $data.currentPlan"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: $data.originalPlan"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: $data.timezone"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: $data.adPlatform"></span>
                                        </td>    
                                        <td>
                                            <span data-bind="text: $data.adTrackingId"></span>
                                        </td>                                        
                                        <td>
                                            <span data-bind="text: $data.userCount"></span>
                                        </td>
                                        <td style="position: relative">
                                            <!-- ko if: $parent.accountIdPropertiesToShow() == $data.idAccount -->
                                                <div data-bind="attr:{id: $data.idAccount}" style="
                                                    position: absolute;
                                                    top: 100%;
                                                    left: 0;
                                                    background: white;
                                                    border: 1px solid #ccc;
                                                    padding: 6px 10px;
                                                    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
                                                    z-index: 100;
                                                    white-space: nowrap;">

                                                    <!-- ko foreach: $data.properties -->
                                                        <div data-bind="text: $data"></div>
                                                    <!-- /ko -->
                                                </div>
                                            <!-- /ko -->
                                            <span data-bind="event: {click: $parent.onToggleProperties.bind(this, $data)}"><button class="button-default icon i-eye" type="buttom" data-bind="text: $parent.accountIdPropertiesToShow() == $data.idAccount ? 'Hide Properties' : 'Show Properties'"></button></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: $data.ownerEmail"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: $data.averageViews3Day"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: $data.averageEvents3Day"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: $data.dateAccountCreated"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: $data.isActive == 1 ? 'Active' : 'Inactive' "></span>
                                        </td>
                                    </tr>
                                <!-- /ko -->
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>

            <div class="w-lightbox light-theme " data-bind="">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Properties</h3>
                            <button type="button" data-bind="event: { click: onToggleProperties.bind(this, accountIdPropertiesToShow) }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p data-bind="" class="form-text">[Properties]</p>
                            </div>
                            <div class="form-group">
                                <button data-bind="" class="button-default icon i-copy"><span>Copy Properties</span></button>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onToggleProperties.bind(this, accountIdPropertiesToShow) }" class="btn highlight">Close</button>
                        </div>
                    </div>

                </div>
            </div>
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void{

        this.exportDataCsv = new exportDataCsv();

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfYear = new Date(date.getFullYear(), 0, 1);

        this.accountsGraph = new amCharts_v4_date_basic_template("accountsGraph", this.getTemplateViewModel(), this.caller);

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('usageStats');

        this.dateRangeFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateRangeFilter.setStartPickerId('dateRangeStartDatePicker');
        this.dateRangeFilter.setEndPickerId('dateRangeEndDatePicker');
        this.dateRangeFilter.setDateRange(firstOfYear, date);

        this.pagination = new pagination_template('pagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.averageViewsTooltip = new infoButton_template('averageViewsTooltip', this.getTemplateViewModel(), this.caller);
        this.averageEventsTooltip = new infoButton_template('averageEventsTooltip', this.getTemplateViewModel(), this.caller);

        this.resultsInfo = new resultsInfo_template('resultsInfo', this.getTemplateViewModel(), this.caller);
    }

        /**
     * Build the date Picker calendar.
     */
    public buildDatePickerCalendar() {

        this.dateRangeFilter.buildCalendar();
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string {

        return 'accountDashboard_template';
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(): Object{

        let self = this;

        return {

            accountsTableData: ko.observable([]),
            tableOrdering: ko.observable({ col: null, dir: null}),
            accountIdPropertiesToShow: ko.observable(),
            accountsExportData: ko.observable([]),
            onReorderTableData: function(data, column) {
                self.reorderTableData(data, column)
            },
            onToggleProperties: function(data) {
                self.onToggleProperties(data);
            },
            getAvgViewsTooltip() {

                return self.getAvgViewsTooltip();
            },
            getAvgEventsTooltip() {

                return self.getAvgEventsTooltip();
            },
            onExportData: function(){
                self.onExportData();
            }
        };
    }

    public onExportData(){

        this.caller.getListDataForCSV();
    }    

    public getAvgViewsTooltip() {

        let avgViewsTooltipContent = `<p>Based on the last 3 days.</p>`;

        const avgViewsTooltip = new infoButton_template('avgViewsTooltip', this.getTemplateViewModel(), this.caller);
        avgViewsTooltip.setContent(avgViewsTooltipContent);

        return avgViewsTooltip;
    }

    public getAvgEventsTooltip() {

        let avgEventsTooltipContent = `<p>Based on the last 3 days.</p>`;

        const avgEventsTooltip = new infoButton_template('avgEventsTooltip', this.getTemplateViewModel(), this.caller);
        avgEventsTooltip.setContent(avgEventsTooltipContent);

        return avgEventsTooltip;
    }

    public onToggleProperties(data) {

        if (data.idAccount == this.getTemplateViewModel().accountIdPropertiesToShow()) {

            this.getTemplateViewModel().accountIdPropertiesToShow(null);
        } else {

            this.getTemplateViewModel().accountIdPropertiesToShow(data.idAccount);
        }
    }

    public reorderTableData(data, column){

        const currentOrdering = this.getTemplateViewModel().tableOrdering();

        if(currentOrdering.col == null || currentOrdering.col != column) {

            this.getTemplateViewModel().tableOrdering({ col: column, dir: 'DESC'});
        } else if(currentOrdering.col == column && currentOrdering.dir == 'DESC') {

            this.getTemplateViewModel().tableOrdering({ col: column, dir: 'ASC' });
        } else {

            this.getTemplateViewModel().tableOrdering({ col: null, dir: null });
        }

        this.caller.getAccountsTable(true);
    }

    public getViewModelForRequest() {

        return {

            filters:{

                dateFilterType: this.getTemplateViewModel().dateRangeFilter.selectedFilter(),
                selectedMonth: this.getTemplateViewModel().dateRangeFilter.selectedMonth(),
                selectedWeek: this.getTemplateViewModel().dateRangeFilter.selectedWeek(),
                startDate: this.getTemplateViewModel().dateRangeFilter.startDate(),
                endDate: this.getTemplateViewModel().dateRangeFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateRangeFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateRangeFilter.toRange(),
                tableOrdering: this.getTemplateViewModel().tableOrdering()
            },

            pagination: this.getTemplateViewModel().pagination
        }
    }

    public setViewModelFromRequest() {

    }

    public setResultPage(nbResults, nbPages, execTime) {

        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

    public setCsvExportData(exportData){

        this.getTemplateViewModel().accountsExportData(exportData);
    }

    public exportCsvData() {

        let exportDataView = [];

        exportDataView = this.generateCSVForAccounts();

        this.exportDataCsv.exportToCsv("accounts_export", exportDataView);
    }

    private generateCSVForAccounts() {

        let exportDataView = [];

        for (let exportDataRow of this.getTemplateViewModel().accountsExportData()) {

            let exportDataViewRow = [];

            exportDataViewRow["Account"] = exportDataRow.accountName;
            exportDataViewRow["Current Plan"] = exportDataRow.currentPlan;
            exportDataViewRow["Original Plan"] = exportDataRow.originalPlan;
            exportDataViewRow["Timezone"] = exportDataRow.timezone;
            exportDataViewRow["Ad Platform"] = exportDataRow.adPlatform;
            exportDataViewRow["Ad Tracking ID"] = exportDataRow.adTrackingId;
            exportDataViewRow["User Count"] = exportDataRow.userCount;
            exportDataViewRow["Properties"] = exportDataRow.properties ? exportDataRow.properties.join(", ") : "";
            exportDataViewRow["Owner Contact"] = exportDataRow.ownerEmail;
            exportDataViewRow["Avg Views / Day"] = exportDataRow.averageViews3Day;
            exportDataViewRow["Avg Events / Day"] = exportDataRow.averageEvents3Day;
            exportDataViewRow["Account Created"] = exportDataRow.dateAccountCreated;
            exportDataViewRow["Status"] = exportDataRow.isActive == 1 ? 'Active' : 'Inactive';

            exportDataView.push(exportDataViewRow);
        }

        return exportDataView;
    }    

}


// WEBPACK FOOTER //
// ./js/components/templates/accountDashboard_template.ts